import React, { ReactNode, RefObject } from 'react';
import Slider, { ResponsiveObject } from 'react-slick';

interface CarouselProps {
    slidesToShow: number;
    initialSlide?: number;
    sliderRef: RefObject<Slider>;
    afterChange?: (currentSlide: number) => void;
    children?: ReactNode;
    dark?: boolean;
    responsive?: ResponsiveObject[];
}

const Carousel = ({ afterChange, sliderRef, children, dark, responsive, slidesToShow, initialSlide = 0 }: CarouselProps) => (
    <div className={`carousel ${dark ? 'dark' : ''}`}>
        <Slider ref={sliderRef} initialSlide={initialSlide} slidesToShow={slidesToShow} slidesToScroll={slidesToShow} speed={500} infinite={false} responsive={responsive} afterChange={afterChange} draggable={false} arrows={false}>
            {children}
        </Slider>
    </div>
);

export default Carousel;
